
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, retry, throwError } from 'rxjs';
import { constants } from '../shared/constants';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
@Injectable({
    providedIn: 'root',
  })

export class ActivityLoggerService {
    constructor(private http: HttpClient) {}
    httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      };

      updateActivityLog(input: any): Observable<any> {
        let url = environment.prospektr_sell_backend_base_url + constants.update_activity_log;
        return this.http
          .post<any>(url, input, this.httpOptions)
          .pipe(retry(1), catchError(this.errorHandl));
      }

      errorHandl(error: { error: { message: string; }; status: any; message: any; }) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
          // Get client-side error
          errorMessage = error.error.message;
        } else {
          // Get server-side error
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(() => {
          return errorMessage;
        });
      }
}